import { render, staticRenderFns } from "./SvgSeats.vue?vue&type=template&id=74f8d9cf&"
import script from "./SvgSeats.vue?vue&type=script&lang=js&"
export * from "./SvgSeats.vue?vue&type=script&lang=js&"
import style0 from "./SvgSeats.vue?vue&type=style&index=0&id=74f8d9cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports